export default __webpack_public_path__ + "static/fullContact-icon-d29aa373880ae52a7ed37f0e8f5a87d6.svg";